import { gql } from '@apollo/client'

export const CREATE_AWAY_NOTIFICATIONS_MUTATION = gql`
  mutation createAwayNotifications {
    createAwayNotifications
  }
`
